// Mirrors the backend `ReviewTeam` enum values.
export enum ReviewTeam {
    Unknown = 0,
    Underwriting = 1,
    CollateralDefense = 2,
    UnderwritingManagers = 3,
    Transitions = 4,
    Sales = 5,
}

export const REVIEW_TEAM_LABEL: Record<ReviewTeam, string> = {
    [ReviewTeam.Unknown]: 'Unknown',
    [ReviewTeam.Underwriting]: 'Underwriting',
    [ReviewTeam.CollateralDefense]: 'Collateral Defense',
    [ReviewTeam.UnderwritingManagers]: 'Underwriting Managers',
    [ReviewTeam.Transitions]: 'Transitions',
    [ReviewTeam.Sales]: 'Sales',
};

/** The teams a reviewer can assign, in display order. */
export const ASSIGNABLE_REVIEW_TEAMS = [
    ReviewTeam.Underwriting,
    ReviewTeam.CollateralDefense,
    ReviewTeam.UnderwritingManagers,
    ReviewTeam.Transitions,
    ReviewTeam.Sales,
];

/** A row's teams in display order, without duplicates or `Unknown`. */
export const getReviewTeams = (teams: readonly ReviewTeam[] | null | undefined): ReviewTeam[] =>
    // Display order is the enum value order, so a numeric sort gives it.
    [...new Set(teams ?? [])].filter((team) => team !== ReviewTeam.Unknown).sort((a, b) => a - b);
